export default __webpack_public_path__ + "static/media/project-12.ce2ee5e4.png";